/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig';

export class StandardBackupSchedules {
  /**
  * Vault ID.
  */
  'vaultId': string;
  'scheduleConfig': StandardBackupScheduleConfig;
  /**
  * Backup retention period, in days.
  */
  'backupRetentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "scheduleConfig",
      "baseName": "scheduleConfig",
      "type": "StandardBackupScheduleConfig",
      "format": ""
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StandardBackupSchedules.attributeTypeMap;
  }

  public constructor() {
  }
}

